import React from 'react'

interface ReportCoverImageProps {
  src: string
  alt?: string
  className?: string
  imageClassName?: string
}

export default function ReportCoverImage({
  src,
  alt = '',
  className = '',
  imageClassName = '',
}: ReportCoverImageProps) {
  return (
    <div
      className={[
        'h-72 overflow-hidden md:h-80',
        className,
      ].filter(Boolean).join(' ')}
    >
      <img
        src={src}
        alt={alt}
        className={[
          'block h-full w-full object-cover object-center',
          imageClassName,
        ].filter(Boolean).join(' ')}
      />
    </div>
  )
}
